let paginationReducer = function(data = null, action) {
    switch (action.type) {
        case 'APPLY_PAGINATION':
            return action.data;
        default:
            return data;
    }
};

export default paginationReducer;
